export default {
    async loadProfileData(context) {
        const profileData = await window.axios.get('/api/user/profile');
        this.commit('setProfileData', profileData.data);
    },

    async tokenLogin(context, token) {
        this.commit('setToken', token);
        const profileData = await window.axios.get('/auth/token/login');
        this.commit('login', profileData.data);
    },
};
